import {
    USER_PDF, USER_PDF_SUCCESS, USER_PDF_FAILURE,
    USER_REMOVE, USER_REMOVE_SUCCESS, USER_REMOVE_FAILURE,

    USER_PHOTO_PDF, USER_PHOTO_PDF_SUCCESS, USER_PHOTO_PDF_FAILURE,
    USER_PHOTO_PDF_REMOVE, USER_PHOTO_PDF_REMOVE_SUCCESS, USER_PHOTO_PDF_REMOVE_FAILURE,

    USER_DETAIL_PDF, USER_DETAIL_PDF_SUCCESS, USER_DETAIL_PDF_FAILURE,
    USER_DETAIL_PDF_REMOVE, USER_DETAIL_PDF_REMOVE_SUCCESS, USER_DETAIL_PDF_REMOVE_FAILURE,
    USER_DETAIL_PDF_SOUMU, USER_DETAIL_PDF_SOUMU_SUCCESS, USER_DETAIL_PDF_SOUMU_FAILURE,

    UPLOAD_PDF_FILE, UPLOAD_PDF_FILE_SUCCESS, UPLOAD_PDF_FILE_FAILURE,
    SAVE_PDF_FILE, SAVE_PDF_FILE_SUCCESS, SAVE_PDF_FILE_FAILURE,
    SEARCH_PDF_FILE, SEARCH_PDF_FILE_SUCCESS, SEARCH_PDF_FILE_FAILURE,
    DELETE_PDF_FILE, DELETE_PDF_FILE_SUCCESS, DELETE_PDF_FILE_FAILURE,
    DELETE_PATH, DELETE_PATH_SUCCESS, DELETE_PATH_FAILURE,

    UPDATE_NOTICE_DATE, UPDATE_NOTICE_DATE_SUCCESS, UPDATE_NOTICE_DATE_FAILURE

} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    notify: '',
    pdfData: null,
    updateFilePath: null,
    updateReferencePath: null
  },
  getters: {
    userNotify: state => {
      return state.notify
    },
    pdfData: state => {
      return state.pdfData
    },
    updateFilePath: state => {
      return state.updateFilePath
    },
    updateReferencePath: state => {
      return state.updateReferencePath
    }
  },
  actions: {
    [USER_PDF] ({dispatch, state, commit}, params) {
      var data = {}
      var loadparams = true
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiPost', {url: '/master/users/pdf/', data: data, loadparams: loadparams, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_PDF_FAILURE, res.data)
          } else {
            commit(USER_PDF_SUCCESS, {
              data: res.data,
              callback: params.callback
            })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [USER_REMOVE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiDelete', {url: '/master/users/remove_pdf', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_REMOVE_FAILURE, res.data)
          } else {
            commit(USER_REMOVE_SUCCESS, {
              data: res.data,
              callback: params.callback
            })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [USER_PHOTO_PDF] ({dispatch, state, commit}, params) {
      var data = {}
      var loadparams = true
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiPost', {url: '/master/users/pdf_photo', data: data, loadparams: loadparams, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_PHOTO_PDF_FAILURE, res.data)
          } else {
            commit(USER_PHOTO_PDF_SUCCESS, {
              data: res.data,
              callback: params.callback
            })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [USER_PHOTO_PDF_REMOVE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiDelete', {url: '/master/users/remove_pdf_photo', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_PHOTO_PDF_REMOVE_FAILURE, res.data)
          } else {
            commit(USER_PHOTO_PDF_REMOVE_SUCCESS, {
              data: res.data,
              callback: params.callback
            })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [USER_DETAIL_PDF] ({dispatch, state, commit}, params) {
      var data = {}
      var loadparams = true
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiGet', {url: '/master/users/pdf_detail', data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_DETAIL_PDF_FAILURE, res.data)
          } else {
            commit(USER_DETAIL_PDF_SUCCESS, {
              data: res.data,
              callback: params.callback
            })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    // 総務用名簿印刷（労働者名簿）。ダウンロード＆削除は名簿印刷と同じくフォーム POST（remove_pdf_detail_soumu）で行う
    [USER_DETAIL_PDF_SOUMU] ({dispatch, state, commit}, params) {
      var data = {}
      var loadparams = true
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiGet', {url: '/master/users/pdf_detail_soumu', data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_DETAIL_PDF_SOUMU_FAILURE, res.data)
          } else {
            commit(USER_DETAIL_PDF_SOUMU_SUCCESS, {
              data: res.data,
              callback: params.callback
            })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [USER_DETAIL_PDF_REMOVE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiDelete', {url: '/master/users/remove_pdf_detail', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_DETAIL_PDF_REMOVE_FAILURE, res.data)
          } else {
            commit(USER_DETAIL_PDF_REMOVE_SUCCESS, {
              data: res.data,
              callback: params.callback
            })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [UPLOAD_PDF_FILE] ({dispatch, state, commit}, params) {
      var url = '/master/users/upload_pdf'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(UPLOAD_PDF_FILE_FAILURE, res.data)
          } else {
            commit(UPLOAD_PDF_FILE_SUCCESS, {
              data: res.data,
              callback: params.callback
            })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SAVE_PDF_FILE] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        var url = '/master/users/save_pdf'

        dispatch('apiPost', {url: url, data: params.data, loadparams: false})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SAVE_PDF_FILE_FAILURE, res.data)
              reject()
            } else {
              commit(SAVE_PDF_FILE_SUCCESS, {data: res.data, callback: params.callback})
              resolve(res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [SEARCH_PDF_FILE] ({dispatch, state, commit}, params) {
      var url = '/master/users/search_pdf'
      var data = {}
      var callback = () => {}

      if (params) {
        if (params.callback) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', { url: url, data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SEARCH_PDF_FILE_FAILURE, { data: res.data, callback: callback })
          } else {
            commit(SEARCH_PDF_FILE_SUCCESS, { data: res.data, callback: callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [DELETE_PDF_FILE] ({dispatch, state, commit}, params) {
      var url = '/master/users/delete_pdf'
      var data = {}
      var callback = () => {}

      if (params) {
        if (params.callback) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiPost', { url: url, data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DELETE_PDF_FILE_FAILURE, res.data)
          } else {
            commit(DELETE_PDF_FILE_SUCCESS, { data: res.data, callback: callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [DELETE_PATH] ({dispatch, state, commit}, params) {
      var url = '/master/users/delete_path'
      var data = {}
      var callback = () => {}

      if (params) {
        if (params.callback) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiPost', { url: url, data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DELETE_PATH_FAILURE, res.data)
          } else {
            commit(DELETE_PATH_SUCCESS, { data: res.data, callback: callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [UPDATE_NOTICE_DATE] ({dispatch, state, commit}, params) {
      var url = '/master/users/update_notice_date'
      var data = {}
      var callback = () => {}

      if (params) {
        if (params.callback) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiPost', { url: url, data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(UPDATE_NOTICE_DATE_FAILURE, res.data)
          } else {
            commit(UPDATE_NOTICE_DATE_SUCCESS, { data: res.data, callback: callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [USER_PDF_FAILURE] (state, data) {
      console.log('USER_PDF_FAILURE')
      state.notify = {message_i18n: 'messages.pdf.danger', danger: true}
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.long)
    },
    [USER_PDF_SUCCESS] (state, data) {
      console.log('USER_PDF_SUCCESS')
      data.callback(data.data)
    },
    [USER_REMOVE_FAILURE] (state, data) {
      console.log('USER_REMOVE_FAILURE')
      state.notify = {message_i18n: 'messages.delete.danger', danger: true}
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.normal)
    },
    [USER_REMOVE_SUCCESS] (state, data) {
      console.log('USER_REMOVE_SUCCESS')
      state.notify = { message_i18n: 'user.remove_success_message', danger: true }
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
      data.callback(data.data)
    },
    [USER_PHOTO_PDF_FAILURE] (state, data) {
      console.log('USER_PHOTO_PDF_FAILURE')
      state.notify = { message_i18n: 'messages.pdf.danger', danger: true }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.long)
    },
    [USER_PHOTO_PDF_SUCCESS] (state, data) {
      console.log('USER_PHOTO_PDF_SUCCESS')
      data.callback(data.data)
    },
    [USER_PHOTO_PDF_REMOVE_FAILURE] (state, data) {
      console.log('USER_PHOTO_PDF_REMOVE_FAILURE')
      state.notify = {message_i18n: 'messages.pdf.danger', danger: true}
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.long)
    },
    [USER_PHOTO_PDF_REMOVE_SUCCESS] (state, data) {
      console.log('USER_PHOTO_PDF_REMOVE_SUCCESS')
      data.callback(data.data)
    },
    [USER_DETAIL_PDF_FAILURE] (state, data) {
      console.log('USER_DETAIL_PDF_FAILURE')
      state.notify = {message_i18n: 'messages.pdf.danger', danger: true}
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.long)
    },
    [USER_DETAIL_PDF_SUCCESS] (state, data) {
      console.log('USER_DETAIL_PDF_SUCCESS')
      data.callback(data.data)
    },
    [USER_DETAIL_PDF_SOUMU_FAILURE] (state, data) {
      console.log('USER_DETAIL_PDF_SOUMU_FAILURE')
      state.notify = {message_i18n: 'messages.pdf.danger', danger: true}
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.long)
    },
    [USER_DETAIL_PDF_SOUMU_SUCCESS] (state, data) {
      console.log('USER_DETAIL_PDF_SOUMU_SUCCESS')
      data.callback(data.data)
    },
    [USER_DETAIL_PDF_REMOVE_FAILURE] (state, data) {
      console.log('USER_DETAIL_PDF_REMOVE_FAILURE')
      state.notify = {message_i18n: 'messages.pdf.danger', danger: true}
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.long)
    },
    [USER_DETAIL_PDF_REMOVE_SUCCESS] (state, data) {
      console.log('USER_DETAIL_PDF_REMOVE_SUCCESS')
      data.callback(data.data)
    },
    [UPLOAD_PDF_FILE_FAILURE] (state, data) {
      console.log('UPLOAD_PDF_FILE_FAILURE')
      window.alert('PDFファイルを選択してください。')
    },
    [UPLOAD_PDF_FILE_SUCCESS] (state, data) {
      console.log('UPLOAD_PDF_FILE_SUCCESS')
      state.updateReferencePath = data.data.reference_path
      state.updateFilePath = data.data.file_path
      if (data.callback) {
        data.callback()
      }
    },
    [SAVE_PDF_FILE_FAILURE] (state, data) {
      console.log('SAVE_PDF_FILE_FAILURE')
    },
    [SAVE_PDF_FILE_SUCCESS] (state, data) {
      console.log('SAVE_PDF_FILE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    },
    [SEARCH_PDF_FILE_FAILURE] (state, data) {
      console.log('SEARCH_PDF_FILE_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [SEARCH_PDF_FILE_SUCCESS] (state, params) {
      console.log('SEARCH_PDF_FILE_SUCCESS')
      var data = params.data
      state.pdfData = data
      if (params.callback) {
        params.callback()
      }
    },
    [DELETE_PDF_FILE_FAILURE] (state, data) {
      console.log('DELETE_PDF_FILE_FAILURE')
    },
    [DELETE_PDF_FILE_SUCCESS] (state, data) {
      console.log('DELETE_PDF_FILE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    },
    [DELETE_PATH_FAILURE] (state, data) {
      console.log('DELETE_PATH_FAILURE')
    },
    [DELETE_PATH_SUCCESS] (state, data) {
      console.log('DELETE_PATH_SUCCESS')
    },
    [UPDATE_NOTICE_DATE_FAILURE] (state, data) {
      console.log('UPDATE_NOTICE_DATE_FAILURE')
    },
    [UPDATE_NOTICE_DATE_SUCCESS] (state, data) {
      console.log('UPDATE_NOTICE_DATE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user-pdf.js